import React, { useCallback } from 'react';

import { MdOutlineDelete } from 'react-icons/md';
import { FormattedMessage } from 'react-intl';

import { Button } from '@shared/components';

import {
  MAX_ATTACHMENT_COUNT,
  MAX_EMAIL_SIZE_MB,
  MAX_MBATTACHMENT_COUNT,
} from '../../constants';
import styles from './AttachmentFiles.less';
import { formatSize } from './utils';

interface AttachmentProps {
  files: File[];
  setFiles: React.Dispatch<React.SetStateAction<File[]>>;
  isMultiple?: boolean;
}
export default function AttachmentFiles({
  files,
  setFiles,
  isMultiple = true,
}: AttachmentProps) {
  const attachmentCount = isMultiple
    ? MAX_ATTACHMENT_COUNT
    : MAX_MBATTACHMENT_COUNT;
  const handleRemoveFile = useCallback(
    (fileToRemove: File) => {
      setFiles(prevFiles =>
        prevFiles.filter(
          file =>
            !(
              file.name === fileToRemove.name &&
              file.lastModified === fileToRemove.lastModified &&
              file.size === fileToRemove.size
            ),
        ),
      );
    },
    [setFiles],
  );

  if (files.length > 0) {
    return (
      <ul className={styles.fileList}>
        {files.map(file => (
          <li
            className={styles.fileListItem}
            key={`${file.name}-${file.lastModified}-${file.size}`}
          >
            <FormattedMessage
              id="messaging.attachment.file"
              values={{
                fileName: file.name,
                fileSize: formatSize(file.size),
              }}
            />
            <Button
              icon={<MdOutlineDelete />}
              onClick={() => handleRemoveFile(file)}
              shape="round"
              size="small"
            />
          </li>
        ))}
        <li className={styles.fileListItemTotal} key="total">
          <FormattedMessage
            id="messaging.attachment.total"
            values={{
              maxTotalSize: MAX_EMAIL_SIZE_MB,
              totalSize: formatSize(
                files.reduce((sum, file) => sum + file.size, 0),
              ),
              filesCount: files.length,
              maxFiles: attachmentCount,
            }}
          />
        </li>
      </ul>
    );
  }

  return null;
}
